export const formatDate = (dateString) => {
    let p = dateString.match(/\d{4}/g);
    let date = new Date([p[0], ...p[1].match(/\d{2}/g)].join('-'));

    return date.toLocaleDateString();
};